// extracted by mini-css-extract-plugin
export var pffCol = "CreditCardForm_pffCol__fkoV6";
export var pffInline = "CreditCardForm_pffInline__jQ2ir";
export var pffRow = "CreditCardForm_pffRow__ccaTR";